/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import CakeIcon from '@mui/icons-material/Cake'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import HeightIcon from '@mui/icons-material/Height'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import FingerprintIcon from '@mui/icons-material/Fingerprint'
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly'
import WineBarIcon from '@mui/icons-material/WineBar'
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms'
import GrassIcon from '@mui/icons-material/Grass'
import ScienceIcon from '@mui/icons-material/Science'
import WorkIcon from '@mui/icons-material/Work'
import SchoolIcon from '@mui/icons-material/School'
import HomeIcon from '@mui/icons-material/Home'
import TempleBuddhistIcon from '@mui/icons-material/TempleBuddhist'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import TranslateIcon from '@mui/icons-material/Translate'
import NotesIcon from '@mui/icons-material/Notes'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import PermIdentityIcon from '@mui/icons-material/PermIdentity'
import AnimationIcon from '@mui/icons-material/Animation'
import SearchIcon from '@mui/icons-material/Search'
import BalanceIcon from '@mui/icons-material/Balance'
import LabelIcon from '@mui/icons-material/Label'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, hingeProfileBackgroundColor, hingeProfileImageDimension, swipelyticsTurquoise, profPicDefaultURL, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileTextColor, tinderProfilePromptTextColor, tinderProfileItemDividerOpacity, tinderProfileItemBoxShadow, tinderProfileItemBorderWidth, tinderProfileItemBorderRadius, tinderProfileImageWidth, tinderProfileImageIndicatorWidth, tinderLeadImageHeight, tinderImageHeight } from '../../../../../helpers/variableDefaults'
import { inchesToFeetString, inchesToFeetStringTinder } from '../../../../../helpers/globalHelpers'

export const showLookingForJSX = (datingProfile) => {
  return (
    (
      'datingIntentions' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.datingIntentions.length > 0
      && datingProfile.bio.vitalInfo.datingIntentions !== 'Prefer not to say'
    )
    ||
    (
      'relationshipType' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.relationshipType.length > 0
      && datingProfile.bio.vitalInfo.relationshipType !== 'Prefer not to say'
    )
    ||
    (
      'familyPlans' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.familyPlans.length > 0
      && datingProfile.bio.vitalInfo.familyPlans !== 'Prefer not to say'
    )
    ||
    (
      'children' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.children.length > 0
      && datingProfile.bio.vitalInfo.children !== 'Prefer not to say'
    )
  )
}

export const tinderLookingForJSX = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile, width) => {
  
  // console.log('showLookingForJSX ->', showLookingForJSX())

  const lookingForItemJSX = (key, value) => {

    return (
      <Box
        key={key}
        sx={{
          mr: 1, my: 0.5,
          px: 1, py: .75,
          // border: 2,
          backgroundColor: '#505050',
          borderRadius: 5,
          borderColor: 'black',
          color: tinderProfileTextColor,
          fontSize: '14px',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {(key === 'datingIntentions' || key === 'relationshipType') &&
          <BalanceIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
        }
        {(key === 'children' || key === 'familyPlans') &&
          <ChildFriendlyIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
        }

        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {value}
        </Typography>
        
      </Box>
    )
  }
  
  return (
    showLookingForJSX(datingProfile)
    &&
    <>
      {/* Title — Looking For */}
      <Box
        sx={{
          // mt: (viewFeedbackTrue || giveFeedbackTrue) ? 2 : .5,
          mt: 1, mb: 0,
          pb: 1, px: (viewFeedbackTrue || giveFeedbackTrue) ? 0 : 2,
          width: tinderProfileImageWidth(width),
          color: tinderProfilePromptTextColor,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        < SearchIcon
          sx={{
            width: '20px', height: '20px',
            mr: 1,
          }}
        />
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          Looking for
        </Typography>
      </Box>

      <Box
        sx={{
          pt: 0, pb: 0, px: 2, mb: 1,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
          flexWrap: 'wrap',
        }}
      >
        {/* Dating Intentions */}
        {'datingIntentions' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.datingIntentions.length > 0
          && datingProfile.bio.vitalInfo.datingIntentions !== 'Prefer not to say'
          &&
          lookingForItemJSX('datingIntentions', datingProfile.bio.vitalInfo.datingIntentions)
        }

        {/* Dating Intentions */}
        {'relationshipType' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.relationshipType.length > 0
          && datingProfile.bio.vitalInfo.relationshipType !== 'Prefer not to say'
          &&
          lookingForItemJSX('relationshipType', datingProfile.bio.vitalInfo.relationshipType)
        }
        
        {/* Family Plans */}
        {'familyPlans' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.familyPlans.length > 0
          && datingProfile.bio.vitalInfo.familyPlans !== 'Prefer not to say'
          &&
          lookingForItemJSX('familyPlans', datingProfile.bio.vitalInfo.familyPlans)
        }
        
        {/* Children */}
        {'children' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.children.length > 0
          && datingProfile.bio.vitalInfo.children !== 'Prefer not to say'
          &&
          lookingForItemJSX('children', datingProfile.bio.vitalInfo.children)
        }
      </Box>
    </>
  )
}

export const showLifestyleJSX = (datingProfile) => {
  return (
    (
      'alcohol' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.alcohol.length > 0
      && datingProfile.bio.vitalInfo.alcohol !== 'Prefer not to say'
    )
    ||
    (
      'cigarettes' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.cigarettes.length > 0
      && datingProfile.bio.vitalInfo.cigarettes !== 'Prefer not to say'
    )
    ||
    (
      'weed' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.weed.length > 0
      && datingProfile.bio.vitalInfo.weed !== 'Prefer not to say'
    )
    ||
    (
      'drugs' in datingProfile.bio.vitalInfo
      && datingProfile.bio.vitalInfo.drugs.length > 0
      && datingProfile.bio.vitalInfo.drugs !== 'Prefer not to say'
    )
  )
}
export const tinderLifestyleJSX = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile, width) => {
  
  // console.log('showLookingForJSX ->', showLookingForJSX())

  const lifestyleItemJSX = (key, value) => {

    return (
      <Box
        key={key}
        sx={{
          mr: 1, my: 0.5,
          px: 1, py: .75,
          // border: 2,
          backgroundColor: '#505050',
          borderRadius: 5,
          borderColor: 'black',
          color: tinderProfileTextColor,
          fontSize: '14px',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {(key === 'alcohol') &&
          <WineBarIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
        }
        {(key === 'cigarettes') &&
          <SmokingRoomsIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
        }
        {(key === 'weed') &&
          <GrassIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
        }
        {(key === 'drugs') &&
          <ScienceIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
        }

        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {value}
        </Typography>
        
      </Box>
    )
  }
  
  return (
    showLifestyleJSX(datingProfile)
    &&
    <>
      {/* Title — Lifestyle */}
      <Box
        sx={{
          // mt: (viewFeedbackTrue || giveFeedbackTrue) ? 2 : .5,
          mt: 1, mb: 0,
          pb: 1, px: (viewFeedbackTrue || giveFeedbackTrue) ? 0 : 2,
          color: tinderProfilePromptTextColor,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        < LabelIcon
          sx={{
            width: '20px', height: '20px',
            mr: 1,
          }}
        />
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          Lifestyle
        </Typography>
      </Box>

      <Box
        sx={{
          pt: 0, pb: 0, px: 2, mb: 1,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
          flexWrap: 'wrap',
        }}
      >
        {/* Alcohol */}
        {'alcohol' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.alcohol.length > 0
          && datingProfile.bio.vitalInfo.alcohol !== 'Prefer not to say'
          &&
          lifestyleItemJSX('alcohol', datingProfile.bio.vitalInfo.alcohol)
        }

        {/* Cigarettes */}
        {'cigarettes' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.cigarettes.length > 0
          && datingProfile.bio.vitalInfo.cigarettes !== 'Prefer not to say'
          &&
          lifestyleItemJSX('cigarettes', datingProfile.bio.vitalInfo.cigarettes)
        }
        
        {/* Weed */}
        {'weed' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.weed.length > 0
          && datingProfile.bio.vitalInfo.weed !== 'Prefer not to say'
          &&
          lifestyleItemJSX('weed', datingProfile.bio.vitalInfo.weed)
        }
        
        {/* Drugs */}
        {'drugs' in datingProfile.bio.vitalInfo
          && datingProfile.bio.vitalInfo.drugs.length > 0
          && datingProfile.bio.vitalInfo.drugs !== 'Prefer not to say'
          &&
          lifestyleItemJSX('drugs', datingProfile.bio.vitalInfo.drugs)
        }
      </Box>
    </>
  )
}

export const viewTinderVitalInfoItem = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile, width) => {

  return (
    <Box
      sx={{
        mt: 2,
        // py: 2, px: 2,
        width: tinderProfileImageWidth(width),
        borderRadius: (viewFeedbackTrue || giveFeedbackTrue) ? `${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius} 0px 0px` : tinderProfileItemBorderRadius, 
        boxShadow: tinderProfileItemBoxShadow, 
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      {/* Vital Info */}
      <Box
        sx={{
          // mt: 2,
          py: 2, px: 2,
          // boxShadow: 3, 
          minWidth: tinderProfileImageWidth(width),
          width: tinderProfileImageWidth(width),
          fontWeight: 'bold',
          borderRadius: (viewFeedbackTrue || giveFeedbackTrue) ? `${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius} 0px 0px` : tinderProfileItemBorderRadius, 
          boxShadow: tinderProfileItemBoxShadow, 
          color: tinderProfileTextColor,
          backgroundColor: tinderProfileItemBackgroundColor,
          // backgroundColor: 'white',
          whiteSpace: 'nowrap',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {/* Title — Essentials */}
        <Box
          sx={{
            // mt: (viewFeedbackTrue || giveFeedbackTrue) ? 2 : .5,
            mt: 0, mb: 1,
            px: 0, py: 1,
            color: tinderProfilePromptTextColor,
            display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          < AccountBoxIcon
            sx={{
              width: '20px', height: '20px',
              mr: 1,
            }}
          />
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            Essentials
          </Typography>
        </Box>

        {/* Location */}
        {
          (
            'university' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.university.length > 0
          )
          &&
          <>
            {/* Location */}
            <Box
              sx={{
                pb: .5,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <LocationOnIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* University */}
              <Typography
                sx={{

                }}
              >
                {`less than a mile away`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Height */}
        {'heightInches' in datingProfile.bio.vitalInfo 
        && 'heightCM' in datingProfile.bio.vitalInfo 
        && (isFriendReview || 'inOrCmPreference' in user.bio.vitalInfo)
        && datingProfile.bio.vitalInfo.heightInches > 0 
        && datingProfile.bio.vitalInfo.heightCM > 0 
        && (isFriendReview || user.bio.vitalInfo.inOrCmPreference.length > 0) 
        &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />

            <Box
              sx={{
                // px: 1,
                py: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >
              
              {/* Icon */}
              <HeightIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Height */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {isFriendReview && datingProfile.bio.vitalInfo.inOrCmPreference === 'cm' 
                  ? 
                  `${datingProfile.bio.vitalInfo.heightCM} cm`
                  :
                  isFriendReview && datingProfile.bio.vitalInfo.inOrCmPreference !== 'cm'
                    ?
                    `${inchesToFeetStringTinder(datingProfile.bio.vitalInfo.heightInches)}`
                    :
                    user.bio.vitalInfo.inOrCmPreference === 'cm' 
                      ? 
                      `${datingProfile.bio.vitalInfo.heightCM} cm`
                      :
                      `${inchesToFeetStringTinder(datingProfile.bio.vitalInfo.heightInches)}`
                }
              </Typography>
            </Box>
          </>
        }
        {/* Profession and Employer */}
        {
          (
            (
              'profession' in datingProfile.bio.vitalInfo 
              && datingProfile.bio.vitalInfo.profession.length > 0
            )
            ||
            (
              'employer' in datingProfile.bio.vitalInfo 
              && datingProfile.bio.vitalInfo.employer.length > 0
            ) 
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Profession and Employer */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <WorkIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Profession and Employer */}
              <Typography
                sx={{

                }}
              >
                {
                  'profession' in datingProfile.bio.vitalInfo 
                  && datingProfile.bio.vitalInfo.profession.length > 0
                  && 'employer' in datingProfile.bio.vitalInfo
                  && datingProfile.bio.vitalInfo.employer.length > 0
                    ?
                    `${datingProfile.bio.vitalInfo.profession} at ${datingProfile.bio.vitalInfo.employer}` 
                    :
                    'profession' in datingProfile.bio.vitalInfo 
                    && datingProfile.bio.vitalInfo.profession.length > 0
                      ?
                      `${datingProfile.bio.vitalInfo.profession}`
                      :
                      `${datingProfile.bio.vitalInfo.employer}`
                }
              </Typography>
              
            </Box>
          </>
        }
        

        {/* University */}
        {
          (
            'university' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.university.length > 0
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* University */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <SchoolIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* University */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.university}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Religion (Array) */}
        {
          (
            'religion' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.religion.length > 0
            && !(datingProfile.bio.vitalInfo.religion.includes('Prefer not to say'))
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* University */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <TempleBuddhistIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* University */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.religion.join(', ')}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Current City */}
        {
          (
            'currentCity' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.currentCity.length > 0
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Current City */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <HomeIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Current City */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.currentCity}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Politics */}
        {
          (
            'politics' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.politics.length > 0
            && datingProfile.bio.vitalInfo.politics !== 'Prefer not to say' 
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Politics */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <AccountBalanceIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Politics */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.politics}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Gender */}
        {
          (
            'gender' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.gender.length > 0
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Gender */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <PersonOutlineIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Politics */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.gender}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Sexuality */}
        {
          (
            'sexuality' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.sexuality.length > 0
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Sexuality */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <AnimationIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Politics */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.sexuality}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Languages (Array) */}
        {
          (
            'languages' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.languages.length > 0
            && !(datingProfile.bio.vitalInfo.languages.includes('Prefer not to say'))
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Languages */}
            <Box
              sx={{
                py: 1,
                // width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                width: '100%',
                // maxWidth: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <TranslateIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Languages */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.languages.join(', ')}`}
              </Typography>
              
            </Box>

            {/* Looking for */}
            {
              (viewFeedbackTrue || giveFeedbackTrue) 
              && 
              tinderLookingForJSX(viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile, width)
            }

            {/* Lifestyle */}
            {
              (viewFeedbackTrue || giveFeedbackTrue) 
              && 
              tinderLifestyleJSX(viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile, width)
            }
          </>
        }
      </Box>

      {/* Feedback */}
      {viewFeedbackTrue && datingProfile.bioFeedback.vitalInfoFeedback.feedback.length > 0 && datingProfile.bioFeedback.vitalInfoFeedback.verdict.length > 0 &&
        <Box
          sx={{
            width: tinderProfileImageWidth(width),
            borderRadius: `0px 0px ${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0, backgroundColor: 'gray', opacity: tinderProfileItemDividerOpacity }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.vitalInfoFeedback, 'vitalInfo', datingProfile.type)}

        </Box>
      }
    </Box>
  )
}

